var _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgAboutAppAdvantage = function SvgAboutAppAdvantage(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    d: "M17.804 0H5.222C3.08 0 1.223 1.226.408 3.208c-.814 1.98-.397 4.15 1.137 5.66l.948.943a9.612 9.612 0 0 0-.057 4.095l1.175-.227a8.515 8.515 0 0 0 3.638 5.415 8.518 8.518 0 0 0 4.737 1.434c.398 0 .777-.037 1.175-.075l2.047 2.038c1.004 1 2.274 1.509 3.6 1.509.663 0 1.345-.132 2.009-.396C22.768 22.793 24 20.98 24 18.868V6.17C24 2.755 21.215 0 17.804 0ZM4.918 13.396l1.175-.226c-.644-3.245 1.46-6.396 4.719-7.057l-.228-1.17c.474-.094.948-.15 1.44-.15A7.3 7.3 0 0 1 16.023 6a7.119 7.119 0 0 1 3.07 4.566 7.071 7.071 0 0 1-1.08 5.396c-1.062 1.604-2.71 2.68-4.587 3.057-3.922.811-7.73-1.736-8.508-5.623Zm17.737 5.453c0 1.868-1.213 3.038-2.35 3.51-1.137.471-2.823.49-4.15-.83l-1.459-1.453a8.504 8.504 0 0 0 4.434-3.359 8.395 8.395 0 0 0 1.27-6.396 8.516 8.516 0 0 0-3.638-5.415c-1.895-1.264-4.188-1.717-6.424-1.264l-.228-1.17a9.77 9.77 0 0 0-6.215 4.132 10.64 10.64 0 0 0-.947 1.773l-.455-.452c-1.346-1.34-1.327-3.057-.834-4.208C2.133 2.566 3.327 1.34 5.24 1.34h12.583c2.671 0 4.85 2.17 4.85 4.83v12.68h-.018Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id2, ")"),
    d: "M16.136 12a4.14 4.14 0 0 0-4.15-4.132A4.14 4.14 0 0 0 7.836 12a4.14 4.14 0 0 0 4.15 4.132c2.293 0 4.15-1.868 4.15-4.132Zm-4.15 2.773a2.792 2.792 0 1 1 0-5.585 2.792 2.792 0 1 1 0 5.585Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: -0.01,
    x2: 23.995,
    y1: 11.993,
    y2: 11.993,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 7.852,
    x2: 16.137,
    y1: 11.991,
    y2: 11.991,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#17D3FF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#00EA90"
  })))));
};
export default SvgAboutAppAdvantage;